"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonControl = void 0;
const React = require("react");
const Button_1 = require("../../Button");
const BronsonControl = (props) => {
    const { cardViewActive, onToggleCard, disabledToggle, onChangeBackPage, onChangeForwardPage, disabledBack, disabledForward, onDisplayFields, componentsOnRight, hiddenSelectors, } = props;
    const cardViewControls = (React.createElement("div", { className: 'o-layout__item u-3/5 u-pl-small', style: { borderLeft: '3px solid #f2f2f2' } },
        React.createElement("span", { className: 'u-mr-small' },
            React.createElement(Button_1.BronsonButton, { dataComponent: 'dh-controls-back-page', label: '', click: onChangeBackPage, config: {
                    isDisable: disabledBack,
                    types: ['isSecondary'],
                    icon: {
                        name: 'semantic-back',
                        positionInitial: true,
                    },
                } })),
        React.createElement("span", { className: 'u-mr-small' },
            React.createElement(Button_1.BronsonButton, { dataComponent: 'dh-controls-forward-page', label: '', click: onChangeForwardPage, config: {
                    isDisable: disabledForward,
                    types: ['isSecondary'],
                    icon: {
                        name: 'semantic-forward',
                        positionInitial: true,
                    },
                } }))));
    const selectorControls = (React.createElement("div", { className: 'o-layout__item u-3/5 u-pl-small', style: { borderLeft: '3px solid #f2f2f2' } },
        React.createElement("button", { className: 'c-btn c-btn--link c-btn--secondary' },
            React.createElement("i", { className: 'c-btn__icon c-icon c-icon--[control-divide]' })),
        React.createElement("span", { className: 'u-text-fs-2', "data-component": 'dh-controls-display-fields', onClick: onDisplayFields },
            React.createElement("b", { className: 'u-text-brand u-mh-xsmall' }, "Campos a mostrar"),
            React.createElement("i", { className: 'u-text-brand c-icon c-icon--xsmall c-icon--[semantic-expand]' }))));
    return (React.createElement("div", { "data-component": 'dh-controls-dual-viewer', className: 'o-layout', style: { display: 'flex', flexWrap: 'wrap-reverse' } },
        React.createElement("div", { className: 'o-layout__item u-10/12 u-4/5@m u-1/1@s' },
            React.createElement("div", { className: 'o-layout' },
                React.createElement("div", { className: 'o-layout__item u-2/5 u-pr-small', style: { width: 'auto' } },
                    React.createElement("span", { className: 'u-mr-small' },
                        React.createElement(Button_1.BronsonButton, { dataComponent: 'dh-dualview-button-table', label: '', click: onToggleCard, config: {
                                isDisable: false,
                                types: [
                                    `${cardViewActive ? 'isSecondary' : ''}`,
                                ],
                                icon: {
                                    name: 'semantic-list',
                                    positionInitial: true,
                                },
                            } })),
                    React.createElement("span", null,
                        React.createElement(Button_1.BronsonButton, { dataComponent: 'dh-dualview-button-card', label: '', click: onToggleCard, config: {
                                isDisable: disabledToggle,
                                types: [
                                    `${cardViewActive ? '' : 'isSecondary'}`,
                                ],
                                icon: {
                                    name: 'control-account-detail',
                                    positionInitial: true,
                                },
                            } }))),
                cardViewActive
                    ? cardViewControls
                    : !hiddenSelectors
                        ? selectorControls
                        : null)),
        componentsOnRight && (React.createElement("div", { "data-component": 'dh-controls-right', className: 'o-layout__item u-2/12 u-1/5@m u-1/1@s' },
            React.createElement("div", { className: 'o-layout o-layout--equal-height o-layout--right' },
                React.createElement("div", { className: 'o-layout__item' }, componentsOnRight))))));
};
exports.BronsonControl = BronsonControl;
